import lisa from "@/assets/team-lisa.webp";
import linus from "@/assets/team-linus.webp";
import elin from "@/assets/team-elin.webp";
import johan from "@/assets/team-johan.webp";

export const featuredTeamImages: Record<string, string> = {
  "team-lisa": lisa,
  "team-linus": linus,
  "team-elin": elin,
  "team-johan": johan,
};

export const teamImagesByName: Record<string, string> = {
  "Alva Ohlsson": "/team/Alva Ohlsson.jpg",
  "Angelica Nordmark": "/team/Angelica Nordmark.jpg",
  "Angelica Vesterlund": "/team/Angelica Vesterlund .jpg",
  "Anna-Karin Nylund": "/team/Anna-Karin Nylund .jpg",
  "Cecilia Gustafsson": "/team/Cecilia Gustafsson.jpg",
  "Hanna Marklund": "/team/Hanna Marklund.png",
  "Jessica Smeij": "/team/Jessica Smeij.jpg",
  "Johan Norström": "/team/Johan Norstrom.jpg",
  "Johan Rutberg": "/team/Johan Rutberg.png",
  "Julia Prowse": "/team/Julia Prowse.jpg",
  "Lena Johansson": "/team/Lena Johansson.png",
  "Liubov Koss": "/team/Liubov Koss.jpg",
  "Lovisa Ersson": "/team/Lovisa Ersson .jpg",
  "Maria Isabel Söderström": "/team/maria-isabel.jpeg",
  "Nina Hjortsmark": "/team/Nina Hjortsmark.jpg",
  "Patricia Zingmark": "/team/Patricia Zingmark .png",
  "Per Lindström": "/team/per lindstrom.jpg",
  "Samuel Önnbo": "/team/samuel on.jpg",
  "Sandra Fransson": "/team/Sandra Fransson.jpg",
  "Sebastian Bauer": "/team/Sebastian Bauer .jpg",
  "Simon Larsson": "/team/Simon Larsson.png",
  "Tomas Strandberg": "/team/Tomas Strandberg.jpg",
  "Veronica Östhagen": "/team/Veronica osthagen.jpg",
};

export function getTeamImage(name: string, imageKey: string | null, imageUrl: string | null) {
  return teamImagesByName[name] || (imageKey ? featuredTeamImages[imageKey] : null) || imageUrl || null;
}
